<div style="display: flex;align-items: center;cursor: pointer;" (click)="gotoBackoffice()">
    <div [style.background-color]="grun" class="circel">
        <ng-container *ngIf="!loading else myloading">
            {{countgrun}}
        </ng-container>
    </div>
    <div [style.background-color]="gelb" class="circel">
        <ng-container *ngIf="!loading else myloading">
            {{countgelb}}
        </ng-container>
    </div>
    <div [style.background-color]="rot" class="circel">
        <ng-container *ngIf="!loading else myloading">
            {{countrot}}
        </ng-container>
    </div>
</div>

<ng-template #myloading>
    <mat-spinner diameter="20"></mat-spinner>
</ng-template>